import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { orderBy } from 'lodash';
import { Observable } from 'rxjs';
import { Job, Processor, Response } from '../../../models';

import { DialogService, JobsService, ProcessorService, SnackbarService } from '../../../services';
import { DownloadService } from '../../../services/standard/download.service';
import { BriefModalComponent } from '../../brief-modal/brief-modal.component';
import { UploaderModalComponent } from '../../uploader-modal/uploader-modal.component';
import { ShowDownloadsComponent } from '../show-downloads/show-downloads.component';

@Component({
  selector: 'prism-jobs-table',
  templateUrl: './jobs-table.component.html',
  styleUrls: ['./jobs-table.component.scss']
})
export class JobsTableComponent implements OnInit, OnDestroy {
  jobsLoading$: Observable<boolean> = this.jobsService.areJobsLoading$;
  private paginator: MatPaginator;
  columnHeaders = ['id', 'member', 'address', 'received', 'status', 'finals', 'raws', 'brief', 'add', 'history', 'assets'];
  jobsList = new MatTableDataSource<any>([]);
  openingBrief = false;
  downloadProgress = this.jobsService.downloadProgress;
  paginatorControl = {
    length: 0,
    pageSize: 10,
    pageSizeOptions: [10, 20, 40, 50, 100]
  };
  processor: Processor = null;

  @Input()
  set jobs(jobs: any[]) {
    if (jobs) {
      this.jobsList.data = orderBy(jobs, job => job.received, 'desc');
    }
  }

  @Input()
  set jobsCount(count: number) {
    this.paginatorControl.length = count;
  }

  @Output()
  jobSelected = new EventEmitter<any>();

  @Output()
  paginationEvent = new EventEmitter<PageEvent>();

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    mp.length = this.paginatorControl.length;
    this.paginator = mp;
  }


  goToTimeline(job) {
    this.jobsService.setSelectedJob(job);
    const {id} = job;
    this.router.navigateByUrl(`home/job/history/${id}`);
  }

  constructor(private router: Router,
              private dialogService: DialogService,
              private snackbarService: SnackbarService,
              private downloadService: DownloadService,
              private jobsService: JobsService,
              private processorService: ProcessorService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  openJobPricing(job: any) {
    if (!this.openingBrief) {
      this.jobsService.setSelectedJob(job);
      this.router.navigate(['home', 'job', job.id]);
    }
  }

  openAssetsDownloadDialog(job: Job) {
    this.snackbarService.showSnackbar('Fetching download information.');
    this.downloadService.getDownloadData(job.id)
      .subscribe(
        (downloadDataResponse: Response) => {
          const downloadData = downloadDataResponse.data;
          const dialogRef = this.dialogService.openDialog(ShowDownloadsComponent, {downloadData, job}, {panelClass: 'base-modal-dialog'});
          // TODO: @MARCEL IMPROVE CLEAR DOWNLOAD LINK LOGIC AND SUBSCRIPTION CONTROL
          dialogRef.afterClosed()
            .toPromise()
            .then(
              onClose => this.jobsService.clearDownloadData()
            );
        }
      );

  }

  openBriefModal(job: Job) {
    this.openingBrief = true;
    this.jobsService.setSelectedJob(job);
    const briefDialogRef = this.dialogService.openDialog(BriefModalComponent, {briefs: job.briefs}, {panelClass: 'base-modal-dialog'});
    briefDialogRef.afterClosed()
      .toPromise()
      .then(() => {
        this.openingBrief = false;
      });
  }

  setPaginator(pageEvent: PageEvent) {
    this.paginationEvent.emit(pageEvent);
  }

  addAssets(job) {
    this.processorService.processor$.subscribe((processor) => {
      if (processor) {
        this.dialogService.openDialog(UploaderModalComponent, {
          jobsCount: processor.jobsCount,
          serviceType: Object.keys(processor.skills)[0],
          job
        }, {
          height: '90vh',
          panelClass: 'base-modal-dialog'
        });
      }
    });
  }
}
